import { GoogleAds } from '@sgcmpteltd/uikit-next';

import {
  ptoPopup as ptoPopupGoogleAdsConfig,
} from '@/configs/google/ads/mobile';
import { useWindowMessageListen } from '@/hooks/use-window-message-listen';

import styles from './styles.module.scss';
import type { Component } from './types';
import { updatePtoAdsSchema } from './validation';

export const Trigger: Component = ({
  onTrigger,
}) => {
  const {
    isMessageListening,
  } = useWindowMessageListen({
    schema: updatePtoAdsSchema,
    onTrigger: (output) => {
      onTrigger?.(output.data);
    },
  });

  return (
    isMessageListening && (
      <div
        className={styles.containerRoot}>
        <GoogleAds
          adUnitPath={ptoPopupGoogleAdsConfig.adUnitPath}
          divId={ptoPopupGoogleAdsConfig.divId}
          slot={ptoPopupGoogleAdsConfig.slot} />
      </div>
    )
  );
};
